import { MoovFileDTO } from "./moovFileDTO";
import { MoovStepConfigurationDTO } from "./moovStepConfigurationDTO";
import { MoovStepScheduleDTO } from "./moovStepScheduleDTO";

export class MoovStepInstanceDTO{
    public id!: number;
    public moovStepConfiguration!: MoovStepConfigurationDTO;
    public inputFile!: MoovFileDTO;
    public outputFile!: MoovFileDTO;
    public logFile?: MoovFileDTO;
    public outputParameterValues!: string;
    public startedExecutionAt!: string;
    public finishedExecutionAt!: string;
    public undoInProcess!: boolean;
    public undoError!: boolean;
    public undoMessage!: string;
    public undoneAt!: string;
    public approved!: string;
    public approvedByUserId!: number;
    public suspended!: boolean;
    public success:boolean = false;
    public permanentError!: boolean;
    public errors!: string;
    public approvalId!: string;
    public skipped!: boolean;
    public moovStepSchedule!: MoovStepScheduleDTO;
    public remarks!: string;
    public purgeOutputParameterValuesAfter!: string;
    public purgedOutputParameterValuesAt!: string;
}